module.exports = __webpack_public_path__ + "img/tabar_home2.ab27a6e6.png";